export default "__VITE_ASSET__DIDjF9JN__"